module.exports = __webpack_public_path__ + "static/media/logo.8ea0a2f5.svg";